import React from 'react';
import HomePage from '../components/landingSite/home'

const Home = () => {
    return (
        <HomePage />
    )
}

export default Home;